import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import typography from "../../../cssUtils/typography";
import AppDropdown from "../../../common/app-dropdown";

const SingleContact = (props) => {
  const {
    setCountryCode,
    setDialCode,
    setName,
    // Add these props to receive current values from parent
    nameValue = "",
    countryCodeValue = "",
    phoneNumberValue = "",
  } = props;

  // Initialize local state from parent values
  const [singleContactCountryCode, setSingleContactCountryCode] =
    useState(countryCodeValue);
  const [phoneNumberSuffix, setPhoneNumberSuffix] = useState(phoneNumberValue);
  const [phoneError, setPhoneError] = useState("");
  const [name, setNameLocal] = useState(nameValue);

  const [nameError, setNameError] = useState("");

  const tenant = localStorage.getItem("tenant");
    console.log("isEditMode in SingleContact:", props?.isEditMode);
  // Add effect to sync parent values to local state
  useEffect(() => {
    setNameLocal(nameValue);
    setSingleContactCountryCode(countryCodeValue);
    setPhoneNumberSuffix(phoneNumberValue);

    // Reset error states when form is cleared
    if (!nameValue && !countryCodeValue && !phoneNumberValue) {
      setNameError("");
      setPhoneError("");
    }
  }, [nameValue, countryCodeValue, phoneNumberValue]);

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhoneNumberSuffix(value);

    // Conditional validation based on country code
    if (singleContactCountryCode === "971") {
      // UAE numbers must be exactly 9 digits
      if (value.length !== 9) {
        setPhoneError("UAE phone number must be exactly 9 digits");
      } else {
        setPhoneError("");
      }
    } else {
      // Other countries must have exactly 10 digits
      if (value.length !== 10) {
        setPhoneError("Phone number must be exactly 10 digits");
      } else {
        setPhoneError("");
      }
    }
  };

  const handleConcatenation = () => {
    const isValidUAE =
      singleContactCountryCode === "971" && phoneNumberSuffix.length === 9;
    const isValidOther =
      singleContactCountryCode !== "971" && phoneNumberSuffix.length === 10;

    if (singleContactCountryCode && (isValidUAE || isValidOther)) {
      setCountryCode(singleContactCountryCode);
      setDialCode(phoneNumberSuffix);
    } else {
      setCountryCode("");
      setDialCode("");
    }
  };

  // Handle first name changes and update parent component state
  const handleFirstNameChange = (e) => {
    const inputValue = e.target.value;

    setNameLocal(inputValue);
    setName(inputValue);
  };

  useEffect(() => {
    handleConcatenation();
  }, [singleContactCountryCode, phoneNumberSuffix]);
  console.log("isEditMode in SingleContact:", props?.isEditMode);

  // Country code options based on tenant
  const getCountryCodeOptions = () => {
    const baseOptions = [
      { label: "IND (+91)", value: "91" },
      { label: "UK (+44)", value: "44" },
      { label: "KE (+254)", value: "254" },
    ];
    
    if (!["onetouchindia", "oneTouchIndiaMarketingLive"].includes(tenant)) {
      baseOptions.push(
        { label: "US (+1)", value: "1" },
        { label: "UAE (+971)", value: "971" },
      );
    }
    return baseOptions;
  };

  const handleCountryCodeSelect = (value) => {
    setSingleContactCountryCode(value);
  };

  return (
    <>
      {/* First Name and Last Name Fields */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Typography sx={{ ...typography.h2, mt: 1, mb: 1 }}>
            Contact Information
          </Typography>
        </Grid>
        <Grid item xs={12}>
          
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            value={name}
            onChange={handleFirstNameChange}
            required
            error={nameError !== ""}
            helperText={nameError}
            disabled={props?.isEditMode}
            InputLabelProps={{
              sx: typography.bodyLarge,
            }}
            inputProps={{
              sx: typography.bodyLarge,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              },
              '& fieldset': {
                borderColor: '#DFE5EC',
              },
            }}
          />
        </Grid>
      </Grid>

      {/* Original Phone Number Fields */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={3} md={4}>
          <FormControl fullWidth>
            <AppDropdown
              menuItems={getCountryCodeOptions()}
              selectedValue={singleContactCountryCode}
              onMenuSelect={handleCountryCodeSelect}
              variant="outlined"
              disabled={props?.isEditMode}
              endIcon={<ExpandMoreIcon />}
              sx={{
                width: "100%",
                height: 56,
                textAlign: "left",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  ...typography.bodyLarge,
                  whiteSpace: "nowrap",
                }}
              >
                {singleContactCountryCode
                  ? getCountryCodeOptions().find(
                    (opt) => opt.value === singleContactCountryCode
                  )?.label
                  : "Select Country Code *"}
              </span>
            </AppDropdown>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={9} md={8}>
         
          <TextField
            fullWidth
            id="outlined-basic"
            label="Phone Number"
            variant="outlined"
            value={phoneNumberSuffix}
            onChange={handlePhoneNumberChange}
            required
            disabled={props?.isEditMode}
            InputLabelProps={{
              sx: typography.bodyLarge,
            }}
            inputProps={{
              sx: typography.bodyLarge,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              },
              '& fieldset': {
                borderColor: '#DFE5EC',
              },
            }}
          />
        </Grid>
        {phoneError && (
          <Typography
            color="error"
            sx={{
              ...typography.bodySmall,
              display: "block",
              mt: 1,
              ml: 1,
              color: "#d32f2f",
            }}
          >
            {phoneError}
          </Typography>
        )}
      </Grid>
    </>
  );
};

export default SingleContact;